import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    username: localStorage.getItem("username") || "",
    userId: localStorage.getItem("userid") || "",
    userProfilePic: localStorage.getItem("userProfilePic") || "/avatar.svg",
    userProfilePicDownloadUrl:
      localStorage.getItem("userProfilePicDownloadUrl") || "/avatar.svg",
    clientId: localStorage.getItem("clientId") || "",
    cardCurrencyName: JSON.parse(localStorage.getItem("cardCurrencyName")) || {
      value: 2,
      label: "AUD",
      symbol: "$",
    },
  },
  reducers: {
    setUsername: (state, action) => {
      localStorage.setItem("username", action.payload);
      state.username = action.payload;
    },
    setUserIdStore: (state, action) => {
      localStorage.setItem("userid", action.payload);
      state.userId = action.payload;
    },
    setUserProfilePicDownloadUrl: (state, action) => {
      localStorage.setItem("userProfilePicDownloadUrl", action.payload);
      state.userProfilePicDownloadUrl = action.payload;
    },
    setUserProfilePic: (state, action) => {
      localStorage.setItem("userProfilePic", action.payload);
      state.userProfilePic = action.payload;
    },
    setCardCurrencyName: (state, action) => {
      localStorage.setItem("cardCurrencyName", JSON.stringify(action.payload)); // ✅ stringify before saving
      state.cardCurrencyName = action.payload;
    },
    setClientId: (state, action) => {
      localStorage.setItem("clientId", action.payload);
      state.clientId = action.payload;
    },
    clearClientId: (state) => {
      localStorage.removeItem("clientId");
      state.clientId = null;
    },
    clearCardCurrencyName: (state) => {
      localStorage.removeItem("cardCurrencyName");
      state.cardCurrencyName = null;
    },
    clearUsername: (state) => {
      localStorage.removeItem("username");
      state.username = null;
    },
    clearUserProfilePicDownloadUrl: (state) => {
      localStorage.removeItem("userProfilePicDownloadUrl");
      state.userProfilePicDownloadUrl = null;
    },
    clearUserId: (state) => {
      localStorage.removeItem("userid");
      state.userId = null;
    },
    clearUserProfilePic: (state) => {
      localStorage.removeItem("userProfilePic");
      state.userProfilePic = null;
    },
  },
});

export const {
  setUsername,
  clearUsername,
  setUserIdStore,
  clearUserId,
  setUserProfilePic,
  clearUserProfilePic,
  clearUserProfilePicDownloadUrl,
  setUserProfilePicDownloadUrl,
  setCardCurrencyName,
  clearCardCurrencyName,
  setClientId,
  clearClientId,
} = userSlice.actions;
export default userSlice.reducer;
